/** @file Motion duration and easing tokens for consistent animations. */

export const motion = {
  duration: {
    fast: '120ms',
    standard: '200ms',
    slow: '320ms',
    hero: '560ms'
  },
  easing: {
    standard: 'cubic-bezier(.2, .8, .2, 1)',
    decel: 'cubic-bezier(0, 0, .2, 1)',
    accel: 'cubic-bezier(.4, 0, 1, 1)'
  }
};
